import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col modal-box w-96 bg-white" }
const _hoisted_2 = { class: "flex justify-end w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Assign Cook")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-small" }, "Select Cook to assign this order to. If they do not accept within 5 mins, you can assign someone else.", -1)
const _hoisted_8 = ["value", "v-model"]
const _hoisted_9 = ["value", "onClick", "to"]
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Assign", -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bg-gray-400 flex fixed w-full h-screen items-center justify-center shadow",
    style: _normalizeStyle({'opacity': '.9'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "modal-button-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideCook && _ctx.hideCook(...args))),
          style: {'padding': '0px'}
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("input", {
          id: "cook",
          value: _ctx.Inputs[0],
          "v-model": _ctx.CookId,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onscroll && _ctx.onscroll(...args))),
          type: "text",
          class: "input-style",
          placeholder: "Cook"
        }, null, 8, _hoisted_8),
        (_ctx.cook)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "absolute rounded-md bg-white p-2 shadow-lg w-48 z-20 custom-select",
              style: _normalizeStyle({'top': `${_ctx.totalHeight}px`})
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Users, ({
                                Id,
                                FirstName,
                                LastName
                            }, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: FirstName,
                  onClick: ($event: any) => (_ctx.cook = false, _ctx.addInputes(FirstName, LastName)),
                  class: "w-96 min-height list-link",
                  key: idx,
                  to: { name: 'orders-id', params: { id: Id } }
                }, _toDisplayString(FirstName+' '+LastName), 9, _hoisted_9))
              }), 128))
            ], 4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.assignOrder(_ctx.CookId)))
          }, _hoisted_12)
        ])
      ])
    ])
  ], 4))
}